import { z } from "zod";
export const activityTypes = [
    "Login",
    "Claimed Nomination",
    "Verified New",
    "Verified Existing",
    "Purchased",
    "Sent Email",
    "Candidate Modified",
    "Name Verified",
    "Location Verified",
];
export const activityTypeSchema = z.enum(activityTypes);
//# sourceMappingURL=types.js.map